<div class="row mt-2">
  <div class="col-12">
    <nav class="breadcrumb-one" aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="javascript:void(0);">
          <svg class="feather feather-home" fill="none" height="24" stroke="currentColor" stroke-linecap="round"
               stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24"
               xmlns="http://www.w3.org/2000/svg">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
            <polyline points="9 22 9 12 15 12 15 22"></polyline>
          </svg>
        </a></li>
        <li class="breadcrumb-item active" aria-current="page"><a href="/private/settings" translate>Settings</a></li>
        <li class="breadcrumb-item active" aria-current="page" translate>My Data Requests</li>
      </ol>
    </nav>
  </div>
</div>

<div class="dsr-page">

  <!-- Header -->
  <div class="dsr-header">
    <div class="dsr-header-text">
      <h1 class="dsr-title" dir="auto" translate>My Data Requests</h1>
      <p class="dsr-subtitle" dir="auto">{{'You can ask us to give you a copy of your personal data, correct it, delete it, or transfer it. We will respond within 30 days.' | translate}}</p>
    </div>
    <button class="dsr-btn dsr-btn-primary" (click)="openForm()" [hidden]="formOpen">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
           stroke-linecap="round">
        <line x1="12" y1="5" x2="12" y2="19"></line>
        <line x1="5" y1="12" x2="19" y2="12"></line>
      </svg>
      <span translate>New Request</span>
    </button>
  </div>

  <div class="dsr-alert dsr-alert-success" *ngIf="successMessage">{{successMessage}}</div>
  <div class="dsr-alert dsr-alert-error" *ngIf="errorMessage && !formOpen">{{errorMessage}}</div>

  <!-- New request -->
  <div class="dsr-card dsr-form" *ngIf="formOpen">
    <div class="dsr-card-head">
      <h2 translate>New Request</h2>
      <button class="dsr-close" (click)="closeForm()" [disabled]="submitting" aria-label="Close">&times;</button>
    </div>

    <div class="dsr-card-body">
      <label class="dsr-label" for="dsrType" translate>What would you like us to do?</label>
      <div class="dsr-choices">
        <label class="dsr-choice" *ngFor="let t of dsrTypes" [class.selected]="dsrType === t">
          <input type="radio" name="dsrType" [value]="t" [(ngModel)]="dsrType">
          <span class="dsr-choice-title">{{labelFor(t) | translate}}</span>
        </label>
      </div>

      <label class="dsr-label mt-3" for="description" translate>Describe your request</label>
      <textarea class="dsr-textarea" id="description" rows="5" maxlength="5000"
                [(ngModel)]="description" name="description"></textarea>
      <div class="dsr-counter"><span dir="ltr">{{description.length}} / 5000</span></div>

      <div class="dsr-alert dsr-alert-error" *ngIf="errorMessage">{{errorMessage}}</div>

      <div class="dsr-actions">
        <button class="dsr-btn dsr-btn-primary" (click)="submit()" [disabled]="submitting">
          <span *ngIf="!submitting" translate>Submit request</span>
          <span *ngIf="submitting" translate>Sending…</span>
        </button>
        <button class="dsr-btn dsr-btn-ghost" (click)="closeForm()" [disabled]="submitting" translate>Cancel</button>
      </div>
    </div>
  </div>

  <!-- My requests -->
  <div class="dsr-card">
    <div class="dsr-card-head">
      <h2 translate>My Requests</h2>
      <span class="dsr-count" *ngIf="requests.length">{{requests.length}}</span>
    </div>

    <div class="dsr-table-wrap">
      <table class="dsr-table">
        <thead>
        <tr>
          <th translate>Reference</th>
          <th translate>Request</th>
          <th translate>Submitted</th>
          <th translate>Status</th>
          <th translate>Response by</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let r of requests">
          <td class="dsr-ref">{{r.ticketNumber || r.id}}</td>
          <td>
            <div class="dsr-type">{{labelFor(r.dsrType) | translate}}</div>
          </td>
          <td class="dsr-date">{{r.submittedDate | date:'yyyy-MM-dd'}}</td>
          <td>
            <span class="dsr-badge" [ngClass]="statusClass(r)">{{statusLabel(r) | translate}}</span>
            <span class="dsr-tag-extended" *ngIf="r.extended" translate>Extended</span>
          </td>
          <td>
            <div class="dsr-date" *ngIf="r.deadlineDate">{{r.deadlineDate | date:'yyyy-MM-dd'}}</div>
            <div class="dsr-remaining" *ngIf="!isClosed(r) && daysLeft(r) !== null"
                 [class.is-overdue]="daysLeft(r)! < 0" [class.is-soon]="daysLeft(r)! >= 0 && daysLeft(r)! <= 5">
              <ng-container *ngIf="daysLeft(r)! > 0">{{daysLeft(r)}} {{'days left' | translate}}</ng-container>
              <ng-container *ngIf="daysLeft(r) === 0" translate>Due today</ng-container>
              <ng-container *ngIf="daysLeft(r)! < 0" translate>Overdue</ng-container>
            </div>
          </td>
        </tr>

        <tr *ngIf="!loading && requests.length === 0">
          <td colspan="5">
            <div class="dsr-empty">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
              </svg>
              <div translate>You have not made any requests yet.</div>
            </div>
          </td>
        </tr>

        <tr *ngIf="loading">
          <td colspan="5">
            <div class="dsr-empty" translate>Loading…</div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
